export const updateRecentSearches = (state = {}, {recentSearches}: any) => {
  return {
    ...state,
    recentSearches,
  };
};
